import CardsChamados from '../../components/ui/CardsChamados'
import {useState, useEffect} from 'react'

import Header from '../../components/Header';
import Totalizadores from '../../components/ui/CardsTotalizadores';

import { useAuth } from '../../context/AuthContext';


import './Inicial.css'
import Introducao from '../../components/Introducao';
import userEvent from '@testing-library/user-event';
import { API_URL } from '../../config/api';
export default function Inicial(){ 
    const [tickets, setTickets] = useState([])
    const [totalizers, setTotalizers] = useState()
    const {user} = useAuth()
    const token = localStorage.getItem("token");
    const [newTickets, setNewTickets] = useState()

    const getTickets = async ()=>{
        await fetch(`${API_URL}/tickets/openTickets/${user.id}`,{
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })
            .then(response => {
                if (!response.ok) {
                throw new Error(`Erro: ${response.status}`);
                }
                return response.json(); 
                
            })
            .then(data => {
                setTickets(data.tickets)
                setNewTickets(data.ticketsAdd)
                console.log(data)
            })
            .catch(error => {
                console.error('Erro na requisição:', error.message);
            });
    }

    const getTotalizers = async ()=>{
        await fetch(`${API_URL}/tickets/totalizers/${user.id}`,{
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`
            }
        })
            .then(response => {
                if (!response.ok) {
                throw new Error(`Erro: ${response.status}`);
                }
                return response.json(); 
                
            })
            .then(data => {
                setTotalizers(data)
            })
            .catch(error => {
                console.error('Erro na requisição:', error.message);
            });
    }      

    useEffect(() => {
        if (user?.id) {
            console.log("🚨 EXECUTOU USEEFFECT", user.id);
            getTickets();
            setTimeout(() => {
                getTotalizers();
                }, 600);
            }
    }, [user?.id]);

    return(
        <>

        <Header />
            
        <Introducao >
            <h1>Agora é sua vez!</h1>
            <p>Por um dia os papéis se inverteram. Agora você é da TI</p>
            <h2>Resolva chamados • Cumpra o SLA • Ganhe XP • Conquiste o ranking</h2>
        </Introducao>

        <Totalizadores totalizers={totalizers} newTickets={newTickets} />

            {/* chamados */}
        <div className="areaCards">
                {tickets.map(d => 
                    <CardsChamados key={d.ticketId} tickets={d}/>
                )}
        </div>
    </>
        
    )
}